import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { projectsRoutes } from './projects/projects-routing.module';
import { BaseComponent } from './base/base.component';
import { BaseGuard } from './base/base.guard';
import { clientsRoutes } from './clients/clients-routing.module';
import { SuperAdminGuard } from './auth/superadmin.guard';
import { widgetsRoutes } from './widgets/widgets-routing.module';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { usersRoutes } from './users/users-routing.module';
import { settingsRoutes } from './settings/settings-routing.module';

const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'password/forgot', component: ForgotPasswordComponent },
  { path: 'password/reset/:token', component: ResetPasswordComponent },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard, BaseGuard],
    children: [
      {
        path: '',
        component: DashboardComponent
      },
      ...projectsRoutes,
      ...clientsRoutes,
      ...widgetsRoutes,
      ...usersRoutes,
      ...settingsRoutes
    ]
  },
  //{ path: '', redirectTo: '/projects', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard,
    SuperAdminGuard
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts